import React from 'react'

/**
 * @typedef {object} LoaderProps
 * @property {boolean} active
 * @property {boolean} inverted
 * @property {boolean|object} [dimmer]
 * @property {React.ReactNode} [children]
 * @property {string} [elmId]
 */
import {
  Loader as SemanticLoader,
  Dimmer as SemanticDimmer,
} from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Loader = _props => {
  const {
    active = false,
    inverted = false,
    dimmer = {},
    children = null,
    elmId = null,
    ...rest
  } = _props
  return (
    <SemanticDimmer
      {...dimmer}
      active={active}
      inverted={inverted}
      className={cx('dimmer')}
    >
      <SemanticLoader
        {...rest} // rest comes first, so we overwrite any default props with ours
        active={active}
        inverted={inverted}
        data-elm-id={elmId}
      >
        {children}
      </SemanticLoader>
    </SemanticDimmer>
  )
}

export default Loader
